import React from 'react';
import head from './pragyaa_header.jpeg'; // Tell webpack this JS file uses this image
//import ImageMapper from 'react-img-mapper';

console.log(head); 

function Header() {
  /*const MAP = {
    name: 'my-map',
    // GET JSON FROM BELOW URL AS AN EXAMPLE
    areas: './image-area.json',
  };*/
  // Import result is the URL of your image
  return <img src={head} alt="Pragyaa"  width={1600} />;
  //return <ImageMapper src={head} map={MAP} />;
}

export {Header};